/**
 * useSalesBalancesSummary — 미수(AR) 스냅샷 총합 요약 (홈 KPI 미수 잔액용).
 *
 * salesRepo.fetchBalances() 를 1회 호출해 Σ.ar(총 미수)·기준일(asOf)을 도출.
 * 스냅샷 데이터라 delta 비교 없음 — sub 라벨에 기준일 표시용.
 */
import { useEffect, useState } from "react";
import { salesRepo } from "@/services/sales.repository";

export interface SalesBalancesSummary {
  /** 총 미수액 (원) */
  totalAr: number;
  /** 거래처 수 (미수 > 0) */
  count: number;
  /** 스냅샷 기준일 (YYYY-MM-DD). 여러 곳 중 가장 최신 */
  asOf: string;
  loaded: boolean;
  error: string | null;
}

export function useSalesBalancesSummary(enabled = true): SalesBalancesSummary {
  const [state, setState] = useState<SalesBalancesSummary>({
    totalAr: 0,
    count: 0,
    asOf: "",
    loaded: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    salesRepo
      .fetchBalances()
      .then((rows) => {
        if (cancelled) return;
        let totalAr = 0;
        let count = 0;
        let asOf = "";
        for (const r of rows) {
          totalAr += r.ar;
          if (r.ar > 0) count += 1;
          if (r.asOf && r.asOf > asOf) asOf = r.asOf;
        }
        setState({ totalAr: Math.round(totalAr), count, asOf, loaded: true, error: null });
      })
      .catch((e) => {
        if (cancelled) return;
        setState((s) => ({ ...s, loaded: true, error: e instanceof Error ? e.message : String(e) }));
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
